import { Component, State, h, Host, Element, Watch } from '@stencil/core';
import { state, onChange } from './pn-sidenav-store';

@Component({
  tag: 'pn-sidenav-level',
  styleUrl: 'pn-sidenav-level.scss',
  shadow: false,
})
export class PnSidenavLevel {
  @Element() hostElement: HTMLElement;
  @State() level: number = 1;
  @State() levelId: string = '';
  @State() isOpen: boolean = false;
  @State() parentName: string = '';
  @State() parentHref: string = '';
  @State() parentLinkId: string = '';
  @State() alignment: string = 'right';

  async componentWillLoad() {
    const parent = this.hostElement.parentElement;
    if (parent.tagName.toLowerCase() !== 'nav') {
      this.level = 2;
    }
    if (parent.tagName.toLowerCase() === 'pn-sidenav-link') {
      this.parentName = parent.getAttribute('name') + '';
      this.parentHref = parent.getAttribute('href') + '';
      this.parentLinkId = parent.getAttribute('linkid') + '';
      const parentLinkName = this.parentName.toLowerCase().replace(/\W/gi, '_');
      this.levelId = `sidenav-lvl${this.level}-${parentLinkName}`;

      if (parent.getAttribute('current') + '' === 'true') {
        state.openLevel = this.levelId;
        this.onChangeOpenLevel();
      }
    }
    onChange('openLevel', () => {
      this.onChangeOpenLevel();
    });
  }

  @Watch('isOpen')
  onOpen() {}
  onChangeOpenLevel() {
    this.isOpen = state.openLevel === this.levelId;
  }

  render() {
    const attributes = {
      'aria-hidden': this.level > 1 ? !this.isOpen + '' : null,
      'data-level': this.level + '',
      'id': this.levelId ?? '',
    };
    return (
      <Host {...attributes} data-asdfasdf={this.isOpen}>
        <slot />
      </Host>
    );
  }
}
